var _circle, _circle2, _circle3, _circle4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquiggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2563,
    height: 1090,
    viewBox: "0 0 2563 1090",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 625.5,
    cy: 877.5,
    r: 21.5,
    fill: "#1A81F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1666.5,
    cy: 522.5,
    r: 21.5,
    fill: "#FA7E2E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2149,
    cy: 176,
    r: 21,
    fill: "#23C5BF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1124,
    cy: 800,
    r: 20,
    fill: "#7340E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2562 1C2562 1 2445.5 100 2323.5 139.5C2130.37 202.03 2101.05 150.132 1914 229C1680.01 327.656 1691.06 625.708 1474 757.5C1233.49 903.532 1058.04 714.827 791 803.5C596.137 868.207 513.131 980.389 309 1002.5C188.063 1015.6 1 956 1 956M1 1089C115.833 979.167 166.312 908.67 347.5 855.5C558.184 793.674 683.5 941.5 863.5 956C1043.5 970.5 1178.66 667.815 1406 570.5C1649.81 466.135 1842.62 599.478 2014.5 397.5C2116.38 277.78 2129.07 134.449 2272 69C2420.5 1 2562 128 2562 128",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquiggle);
export default __webpack_public_path__ + "static/media/squiggle.5f60c7c85525f602648aa75cd2f72480.svg";
export { ForwardRef as ReactComponent };